// extracted by mini-css-extract-plugin
export default {"TableauBootstrap":"AddCapteurComposante_TableauBootstrap__l1RYb","btn_stylo":"AddCapteurComposante_btn_stylo__8zIQe"};